export const RBPayrollStatus = {
  NOT_STARTED: "NOT_STARTED",
  PENDING_REVIEW: "PENDING_REVIEW",
  ACTIVE: "ACTIVE",
  ON_HOLD: "ON_HOLD",
  // Deprecated: REJECTED is replaced by ON_HOLD and is no longer produced by any
  // mapper. Kept only so existing (now-unreachable) references keep compiling until
  // the follow-up cleanup pass removes them.
  REJECTED: "REJECTED",
} as const;

export const RBPayrollPaymentMethod = {
  RB_PAYROLL: "RB_PAYROLL",
} as const;

export const RBPayrollLocationCreationMode = {
  COPY: "COPY",
  NEW: "NEW",
} as const;

export type RBPayrollStatusValue = typeof RBPayrollStatus[keyof typeof RBPayrollStatus];
export type RBPayrollPaymentMethodValue =
  typeof RBPayrollPaymentMethod[keyof typeof RBPayrollPaymentMethod];
export type RBPayrollLocationCreationModeValue =
  typeof RBPayrollLocationCreationMode[keyof typeof RBPayrollLocationCreationMode];

export interface RBPayrollDocument {
  id: string;
  name: string;
  type: string;
  size: number;
  previewUrl: string;
  uploadedAt: string;
  source: "mock-upload" | "mock-existing" | "s3";
  // Raw S3 object key. Present for documents backed by the RB Pay API — sent
  // back as `voidChequeS3Key` on create/update so an unchanged document is kept.
  s3Key?: string;
}

export interface RBPayrollApprovalState {
  paymentMethod: RBPayrollPaymentMethodValue;
  status: RBPayrollStatusValue;
  approved: boolean;
  submittedAt: string;
  approvedAt: string;
  rejectedAt: string;
  rejectionReason: string;
}

export interface RBPayrollDirectDepositState {
  institutionNumber: string;
  transitNumber: string;
  accountNumber: string;
  document: RBPayrollDocument | null;
  authorizationAccepted: boolean;
}

export interface RBPayrollSetupState {
  locationId: string;
  locationName: string;
  directDeposit: RBPayrollDirectDepositState;
  approval: RBPayrollApprovalState;
  statementPortalUrl: string;
  contactEmail: string;
  meta: {
    updatedAt: string | null;
    source: "fe-mock" | "be";
  };
}

export interface RBPayrollSetupDraft {
  directDeposit: RBPayrollDirectDepositState;
}

export interface RBPayrollPaymentOption {
  id: string;
  type: RBPayrollPaymentMethodValue;
  title: string;
  description: string;
  setupRequired: boolean;
  setupStatus: RBPayrollStatusValue;
  approved: boolean;
  selected: boolean;
}

export interface RBPayrollFieldErrors {
  directDeposit?: {
    institutionNumber?: string;
    transitNumber?: string;
    accountNumber?: string;
    document?: string;
    authorizationAccepted?: string;
  };
}

export interface RBPayrollDuplicateSource {
  locationId: string;
  locationName: string;
  status: RBPayrollStatusValue;
  updatedAt: string | null;
  // Limited, already-masked banking identifiers to help owners pick the right
  // setup to duplicate. The raw account number is never carried here.
  institutionNumber?: string;
  maskedAccount?: string;
}

export interface RBPayrollLocationCreationSelection {
  copyMode: RBPayrollLocationCreationModeValue;
  selectedLocationId: string;
}
